/**
 * SFTP SSH private-key authentication (vs password) for SFTP/FTPS workflow steps.
 *
 * **LaunchDarkly (primary):** boolean flag `jhft_show_sftp_ssh_option` (`FeatureFlags.SHOW_SFTP_SSH_OPTION`).
 * When the LD client is not ready yet, the default is **true** so local dev and unit tests match post-init behavior
 * until LD returns a value; use `VITE_ENABLE_SFTP_SSH_KEY_AUTH=false` to force off without LD (CI or emergency).
 *
 * **Optional build override:** `VITE_ENABLE_SFTP_SSH_KEY_AUTH` — set to `false` / `0` / `no` to force the
 * feature off without LD (e.g. local or emergency). Set to `true` / `1` / `yes` to force on regardless of LD.
 *
 * Vite still inlines `VITE_*` at build time; LD is evaluated at runtime after `launchDarkly.initialize()`.
 */

import { FeatureFlags } from "./launchdarkly-config";
import { isFeatureEnabled } from "./launchdarkly-helpers";

function viteOverride(): boolean | undefined {
	const raw = String(import.meta.env.VITE_ENABLE_SFTP_SSH_KEY_AUTH ?? "").trim().toLowerCase();
	if (raw === "false" || raw === "0" || raw === "no") return false;
	if (raw === "true" || raw === "1" || raw === "yes") return true;
	return undefined;
}

/** When false, UI must not offer SSH key auth for SFTP/FTPS and saves must not send authType "ssh". */
export function isSftpSshKeyAuthFeatureEnabled(): boolean {
	const v = viteOverride();
	if (v === false) return false;
	if (v === true) return true;
	return isFeatureEnabled(FeatureFlags.SHOW_SFTP_SSH_OPTION, true);
}
